import React, { createContext, useState } from "react";
import { dropdownProviderPropTypes } from "../propTypes";

export const DropdownContext = createContext({});

/**
 * DropdownProvider Component - Wraps dropdown components to provide shared context
 * Manages dropdown visibility state and passes configuration to child components
 *
 * @component
 * @param {React.ReactNode} props.children - Dropdown child components (DropdownContent, DropdownItem, etc.)
 * @param {string} props.placement - Positioning placement for the dropdown menu
 * @param {React.ReactNode} props.trigger - Element that triggers dropdown visibility
 * @param {React.RefObject} props.parentRef - Reference to parent for positioning calculations
 * @returns {JSX.Element} Provider component wrapping children with dropdown context
 */
const DropdownProvider = ({ children, placement, trigger, parentRef }) => {
  const [visible, setVisible] = useState(false);

  return (
    <DropdownContext.Provider
      value={{
        visible,
        setVisible,
        placement,
        trigger,
        parentRef,
      }}
    >
      {children}
    </DropdownContext.Provider>
  );
};

DropdownProvider.propTypes = dropdownProviderPropTypes;

export default DropdownProvider;
